<template>
  <div id="get-started">
    <v-toolbar id="main_toolbar" :style="navStyle" dark fixed app clipped-right>
      <v-spacer></v-spacer>
      <v-toolbar-title>
        <img
          :src="$store.state.theme.small_logo"
          class="responsive-img mt-4"
          style="max-height: 35px"
          alt
        />
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <lang-dropdown></lang-dropdown>
    </v-toolbar>
    <div class="pt-5 mt-2"></div>

    <transition name="fade" mode="out-in">
      <template v-if="currentView == 'setup'">
        <setup-bot @onCompleted="onCompleteSetup"></setup-bot>
      </template>
      <template v-else>
        <div class="container text-xs-center" style="margin-top: 45px">
          <div class="row">
            <div class="col s12 m4 offset-m4">
              <img
                src="/static/img/assets/get_started/completed_setup.png"
                alt
                class="responsive-img"
              />
              <h5>{{ $t('congratulations!') }}</h5>
              <p>{{ $t('You finish to setup your bot. You can start your bot and rest now.') }}</p>
              <p style="cursor: pointer" class="text--primary" @click="botdidnotAnswer">
                {{ $t('Why my bot is not answer?') }}
              </p>
              <v-btn
                :href="'https://m.me/' + selectedBot.pageid + '?ref=menu'"
                target="blank"
                color="primary"
                depressed
                style="width: 100%; margin-bottom: 15px"
                >{{ $t('test this bot') }}</v-btn
              >
              <router-link :to="'/' + $i18n.locale() + '/conversation'" style="width: 100%">
                <v-btn color="primary" style="width: 100%; margin-bottom: 15px" depressed>{{
                  $t('Go to main page')
                }}</v-btn>
              </router-link>
            </div>
          </div>
        </div>
      </template>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import LangDropdown from '@/components/elements/LangDropdown'
import api from '@/api'
import config from '@/config'
import SetupBot from './SetupBot'
export default {
  components: {
    SetupBot,
    LangDropdown
  },
  data: function () {
    return {
      currentView: 'setup'
    }
  },
  computed: {
    ...mapGetters({
      botlist: 'botlist',
      isFacebook: 'isFacebook',
      pagelist: 'unsubscribedPage',
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    navStyle() {
      if (this.themeColor == '#FF706B')
        return 'background-image: linear-gradient(to right, #ff6868, #ffd8a4);'
      return `background-image: linear-gradient(to right, ${this.themeColor}, ${this.shadeColor(
        this.themeColor,
        74
      )});`
    },
    themeColor() {
      // linear-gradient(90deg,#ff6868,#ffd8a4)
      return this.$vuetify.theme.primary
    }
  },
  methods: {
    shadeColor(color, percent) {
      var R = parseInt(color.substring(1, 3), 16)
      var G = parseInt(color.substring(3, 5), 16)
      var B = parseInt(color.substring(5, 7), 16)

      R = parseInt((R * (100 + percent)) / 100)
      G = parseInt((G * (100 + percent)) / 100)
      B = parseInt((B * (100 + percent)) / 100)

      R = R < 255 ? R : 255
      G = G < 255 ? G : 255
      B = B < 255 ? B : 255

      var RR = R.toString(16).length == 1 ? '0' + R.toString(16) : R.toString(16)
      var GG = G.toString(16).length == 1 ? '0' + G.toString(16) : G.toString(16)
      var BB = B.toString(16).length == 1 ? '0' + B.toString(16) : B.toString(16)

      return '#' + RR + GG + BB
    },
    botdidnotAnswer() {
      window.location.href =
        'https://blog.zwiz.ai/%E0%B8%81%E0%B8%A3%E0%B8%93%E0%B8%B5%E0%B9%84%E0%B8%AB%E0%B8%99%E0%B8%9A%E0%B9%89%E0%B8%B2%E0%B8%87%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%97%E0%B8%B3%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%9A%E0%B8%AD%E0%B8%97/'
    },
    onCompleteSetup: function () {
      var vm = this
      let bot = Object.assign({}, vm.selectedBot)
      bot.status = true
      let in_status_label = 'start'
      vm.$store.dispatch('loading')
      api.toggleBotStatus(bot, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }

        let newbotlist = vm.botlist
        $.each(newbotlist, function (index, oldbot) {
          if (bot.pageid == oldbot.pageid) {
            newbotlist[index].status = bot.status
            return false
          }
        })
        // console.log(bot)
        vm.botStatus = bot.status
        var prefix = window.location.hostname == 'cms.zwiz.ai' ? 'z_' : ''
        // vm.$ga.event('event', prefix + 'complete_setup', bot.pagename)
        if (vm.$store.state.newcomer) {
          // vm.$ga.event('event', prefix + 'complete_setup_new_sub', bot.pagename)
          vm.$store.dispatch('updateNewcomer', false)
        }
        vm.$store.dispatch('selectBot', bot)
        vm.$store.dispatch('updateBotlist', newbotlist)
        vm.$store.dispatch('addModalWelcome')
        vm.$store.dispatch('loading')
        vm.currentView = 'completed'
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/getstarted/Setup.vue